import { useTranslation } from 'react-i18next';
import { Switch } from '@platform/ui';
import { useAppDispatch } from '@platform/state/hooks';
import { toastShown } from '@platform/state/slices/uiSlice';
import type { IModuleSwitchCellProps } from './IModuleSwitchCellProps';

/**
 * Перемикач «Увімкнено» рядка «Встановлених модулів» як у прототипі v4 (cmRows.sw): активний у кожному рядку, зокрема в основних модулях і
 * дочірніх таблицях. Основний модуль сервер не вимикає — клік пояснює це повідомленням; дочірня таблиця вмикається й вимикається разом зі
 * своїм модулем (підказка це називає); вимкнений модуль — «Вимкнено · записи збережено». Без права customize — лише перегляд.
 */
export function ModuleSwitchCell({ enabled, canEdit, required, hostName, onToggle, offNote }: IModuleSwitchCellProps) {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const why = hostName ? t('sysCust.modules.withModule', { name: hostName }) : required ? t('sysCust.modules.required') : undefined;
  const change = (on: boolean) => {
    if (required) dispatch(toastShown({ kind: 'info', text: t('sysCust.modules.required') }));
    else onToggle(on);
  };
  return (
    <span className="cu-modswitch" title={why}>
      <Switch checked={enabled} onChange={change} label={t('sysCust.modules.enabled')} disabled={!canEdit} />
      {!enabled && <span className="cu-modswitch__note">{offNote ?? t('sysCust.modules.off')}</span>}
    </span>
  );
}
